"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _UpdateSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateSiteSettings"));

var _defaultCompanyProperties = _interopRequireDefault(require("./staging/defaultCompanyProperties"));

var _defaultContactProperties = _interopRequireDefault(require("./staging/defaultContactProperties"));

var _defaultOwnerProperties = _interopRequireDefault(require("./staging/defaultOwnerProperties"));

var _attachedStylesheets = _interopRequireDefault(require("./staging/attachedStylesheets"));

var _default = (0, _redux.combineReducers)({
  updateSiteSettings: _UpdateSiteSettings.default.getReducer(),
  attachedStylesheets: _attachedStylesheets.default,
  defaultCompanyProperties: _defaultCompanyProperties.default,
  defaultContactProperties: _defaultContactProperties.default,
  defaultOwnerProperties: _defaultOwnerProperties.default
});

exports.default = _default;
module.exports = exports.default;